import { FC, useEffect } from 'react';
import Intercom, { hide, update } from '@intercom/messenger-js-sdk';
import { useLocation } from 'react-router';
import { getUser_user } from '~__queries__';
import { checkScreen } from '~utilities';

interface Props {
  user?: getUser_user | null;
}

const IntercomComponent: FC<Props> = ({ user }) => {
  const location = useLocation();

  // Boot intercom so it is available in the app
  useEffect(() => {
    if (!user) {
      return;
    }

    Intercom({
      api_base: 'https://api-iam.intercom.io',
      app_id: 'wy9we2up',
      name: user.name + ' (POS)',
      email: user.email,
      user_id: 'POS_' + user.id,
      company: {
        id: user.company.id,
        name: user.company.name,
      },
      hide_default_message: true,
      hide_default_launcher: true,
      custom_launcher_selector: '#intercom-launcher',
    });
  }, [user]);

  // Everytime location changes we check if we should show the intercom launcher
  useEffect(() => {
    if (!user) {
      return;
    }

    const pagesToShowIntercom = [
      'settings-v2',
      'gateway',
      'competitions',
      'newReports',
      'z-reports-new',
    ];

    const shouldShowIntercom = pagesToShowIntercom.some((page) =>
      checkScreen(location.pathname, page),
    );

    if (shouldShowIntercom) {
      // Restore the launcher on pages where support should be accessible.
      update({ hide_default_launcher: false });
    } else {
      // hide() collapses the entire Intercom widget including the unread badge.
      // update({ hide_default_launcher: true }) alone doesn't suppress the badge
      // — the unread count dot stays visible and blocks the Pay button on POS/QSR views.
      update({ hide_default_launcher: true });
      hide();
    }
  }, [location, user]);

  return null;
};

export default IntercomComponent;
